export const capitalize = (word = '') => {
  if (!word || typeof word !== 'string') return '';
  return word[0].toUpperCase() + word.slice(1);
};

export const pluralize = (n = 0, titles: string[] = [], onlyTitle = false) => {
  const title = titles[
    // eslint-disable-next-line no-nested-ternary
    n % 10 === 1 && n % 100 !== 11
      ? 0
      : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
        ? 1
        : 2
  ];
  return onlyTitle ? title : `${n} ${title}`;
};
